import { Typography } from '@mui/material';
import * as React from 'react';
import { build } from '../../build';

export const VersionInfo = () => {
    return <Typography variant="caption">
        v.{build.commit()}
    </Typography>;
};